module.exports = __webpack_public_path__ + "img/spv.2b89cd76.svg";